module.exports = __webpack_public_path__ + "static/img/quiz-ted.6582c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/update/quiz-ted.png
// module id = mZ/z
// module chunks = 1